import cookie from "react-cookies";
import constants from "../Constants";

export { putFileWithProgress } from "./creatorApi";

const baseURL = constants.baseURL;

async function jobsFetch(path, { auth = false, ...options } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = cookie.load("candidateKey");
    if (token) headers.Authorization = token;
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);
  try {
    const res = await fetch(`${baseURL}${path}`, {
      ...options,
      signal: controller.signal,
      headers: { ...headers, ...options.headers },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const error = new Error(data.error || "Request failed");
      error.status = res.status;
      error.code = data.code;
      error.profile_path = data.profile_path;
      throw error;
    }
    return data;
  } finally {
    clearTimeout(timeout);
  }
}

const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : "";
};

export const listJobs = (params) => jobsFetch(`/jobs${qs(params)}`);
export const getJob = (slug) => jobsFetch(`/jobs/${encodeURIComponent(slug)}`);

export const startJobApplication = (slug) =>
  jobsFetch(`/jobs/${encodeURIComponent(slug)}/apply`, {
    auth: true,
    method: "POST",
    body: "{}",
  });

export const listMyApplications = () =>
  jobsFetch("/jobs/me/applications", { auth: true });
export const getMyApplication = (id) =>
  jobsFetch(`/jobs/me/applications/${id}`, { auth: true });
export const saveMyApplication = (id, body) =>
  jobsFetch(`/jobs/me/applications/${id}`, {
    auth: true,
    method: "PATCH",
    body: JSON.stringify(body),
  });
export const requestApplicationVideoUrl = (id, file) =>
  jobsFetch(`/jobs/me/applications/${id}/video/upload-url`, {
    auth: true,
    method: "POST",
    body: JSON.stringify({ file }),
  });
export const completeApplicationVideo = (id, body) =>
  jobsFetch(`/jobs/me/applications/${id}/video/complete`, {
    auth: true,
    method: "POST",
    body: JSON.stringify(body),
  });
export const submitMyApplication = (id) =>
  jobsFetch(`/jobs/me/applications/${id}/submit`, {
    auth: true,
    method: "POST",
    body: "{}",
  });
export const withdrawMyApplication = (id) =>
  jobsFetch(`/jobs/me/applications/${id}/withdraw`, {
    auth: true,
    method: "POST",
    body: "{}",
  });
